import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../asyncActions/asyncActions';
import {
  FETCH_ALL_PROGRAMS,
  FETCH_ALL_APPLICANT_REGISTERED_PROGRAMS,
  FETCH_PROGRAM,
  FETCH_REGISTERED_PROGRAM,
} from '../../../constants/applicantConstants/programConstants/applicantProgramConstants';
import { closeDialog } from '../../dialogActions/dialogActions';
import { SubmissionError } from 'redux-form';
import { format, getUnixTime, parseISO, startOfDay } from 'date-fns';
import { analytics } from '../../../../config/firebase';
import axios from '../../../../config/axios';
import { fetchProgramDashboardValues } from '../../adminActions/programActions/adminProgramActions';

export const fetchAllApplicantPrograms = (categoryId) => {
  ///  console.log(categoryId, 'categoryId');
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    let programsQuery;

    if (categoryId) {
      programsQuery = firestore
        .collection('programs')
        .where('programCategory', '==', `${categoryId}`)
        .where('hideProgram', '==', false);
    } else {
      programsQuery = firestore
        .collection('programs')
        .where('hideProgram', '==', false);
    }

    const categoryQuery = firestore.collection('categories');

    try {
      dispatch(asyncActionStart());
      let query = await programsQuery.get();

      let programs = [];

      for (let i = 0; i < query.docs.length; i++) {
        let category = await categoryQuery
          .doc(`${query.docs[i].data().programCategory}`)
          .get();

        let program = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
          categoryImage: category.data().categoryImageURL
            ? category.data().categoryImageURL
            : '',
        };
        programs.push(program);
      }

      programs = programs.sort(function (a, b) {
        return (
          new Date(a?.applicationDeadlineDate) -
          new Date(b?.applicationDeadlineDate)
        );
      });

      dispatch({
        type: FETCH_ALL_PROGRAMS,
        payload: { programs },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

export const fetchApplicantProgram = (id) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    /// console.log(id, 'mnb');

    const programQuery = firestore.collection('programs').doc(`${id}`);

    const categoriesQuery = firestore.collection('categories');

    const institutionsQuery = firestore.collection('institutions');

    try {
      dispatch(asyncActionStart());
      let query = await programQuery.get();
      /// console.log(query, 'query');

      let program = [];
      let institutions = [];

      if (query.exists) {
        let categoryQuery = await categoriesQuery
          .doc(`${query.data().programCategory}`)
          .get();
        /// console.log(categoryQuery, 'categoryQuery');

        let institutionQuery = await institutionsQuery
          .where('programs', 'array-contains', `${query.id}`)
          .get();
        /// console.log(institutionQuery, 'institutionQuery');
        for (let i = 0; i < institutionQuery.docs.length; i++) {
          let institution = {
            ...institutionQuery.docs[i].data(),
            id: institutionQuery.docs[i].id,
          };
          institutions.push(institution);
          /// console.log(institution, 'institution');
        }
        let item = {
          id: query.id,
          ...query.data(),
          // programCategoryName: categoryQuery.data().categoryName,
          programInstitutions: institutions,
        };
        /// console.log(item, 'itemss');
        program.push(item);
      }

      if (!query.exists) {
        dispatch(asyncActionFinish());
        return;
      }
      /// console.log(program, 'dispatch');
      dispatch({
        type: FETCH_PROGRAM,
        payload: { program },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

export const fetchRegisteredProgram = (id) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    const registeredProgram = await registeredProgramQuery.get();

    const programRef = firestore
      .collection('programs')
      .doc(`${registeredProgram.data()?.programId}`);

    const programQuery = await programRef.get();

    const usersQuery = firestore
      .collection('users')
      .doc(`${registeredProgram.data().applicantId}`);

    const user = await usersQuery.get();

    let affiliate = {};

    if (Object.keys(user).length && user.data()?.affiliateId) {
      const affiliatesQuery = firestore
        .collection('affiliates')
        .doc(`${user.data()?.affiliateId}`);

      affiliate = await affiliatesQuery.get();
    }

    const institutionQuery = firestore.collection('institutions');

    try {
      dispatch(asyncActionStart());

      let query = await registeredProgramQuery.get();

      let registeredProgram = [];

      if (query.exists) {
        const chosenInstitutionId = query.data().chosenInstitution;
        console.log(chosenInstitutionId, 'chosenInstitutionId');
        let institution;
        if (chosenInstitutionId) {
          institution = await institutionQuery
            .doc(`${chosenInstitutionId}`)
            .get();
        }

        let program = {
          id: query.id,
          ...query.data(),
          institutionDetails: chosenInstitutionId && institution.data(),
          scholarshipFormCompleted:
            Object.keys(affiliate).length && affiliate.data()?.scholarshipWaiver
              ? true
              : query.data()?.scholarshipFormCompleted,
          taxFormsUploaded:
            Object.keys(affiliate).length && affiliate.data()?.scholarshipWaiver
              ? true
              : query.data()?.taxFormsUploaded,
          programDetails: programQuery.data(),
        };
        registeredProgram.push(program);
        // /// console.log(query.data().programId)
        dispatch(fetchApplicantProgram(query.data().programId));
      }

      if (!query.exists) {
        dispatch(asyncActionFinish());
        return;
      }

      dispatch({
        type: FETCH_REGISTERED_PROGRAM,
        payload: { registeredProgram },
      });
      dispatch(asyncActionFinish());
      return registeredProgram;
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// FETCH Applicant REGISTERED PROGRAMS
export const fetchApplicantRegisteredPrograms = (
  id,
  applicantId,
  programId,
  registered
) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    let allRegisteredPrograms = [];
    // Declare allRegisteredPrograms outside of the if blocks

    if (!registered) {
      const applicantRegisteredProgramsQuery = firestore
        .collection('registeredPrograms')
        .where('applicantId', '==', `${id}`);
      const programQuery = firestore.collection('programs');
      const institutionsQuery = firestore.collection('institutions');

      try {
        dispatch(asyncActionStart());
        let query = await applicantRegisteredProgramsQuery.get();

        for (let i = 0; i < query.docs.length; i++) {
          if (query.docs[i].data().programId) {
            let programDetailsQuery = await programQuery
              .doc(`${query.docs[i].data().programId}`)
              .get();
            let instituteQuery = await institutionsQuery
              .doc(`${query.docs[i].data().chosenInstitution}`)
              .get();
            let instituteQuery2 = await institutionsQuery
              .doc(`${query.docs[i].data()?.chosenInstitution2}`)
              .get();

            let program = {
              ...query.docs[i].data(),
              id: query.docs[i].id,
              programDetails: { ...programDetailsQuery.data() },
              instituteDetails: { ...instituteQuery.data() },
              instituteDetails2: { ...instituteQuery2?.data() },
              programStage: query.docs[i].data()?.archive
                ? 'not active'
                : query.docs[i].data()?.programStage,
            };
            allRegisteredPrograms.push(program);
          }
        }
        dispatch(asyncActionFinish());
      } catch (error) {
        dispatch(asyncActionError());
        /// console.log(error);
      }
      dispatch({
        type: FETCH_ALL_APPLICANT_REGISTERED_PROGRAMS,
        payload: { allRegisteredPrograms },
      });
    }

    // CHECK FOR ALREADY REGISTERED
    if (registered) {
      const applicantRegisteredProgramsQuery = firestore
        .collection('registeredPrograms')
        .where('applicantId', '==', `${applicantId}`)
        .where('programId', '==', `${programId}`);
      const programQuery = firestore.collection('programs');

      try {
        dispatch(asyncActionStart());
        let query = await applicantRegisteredProgramsQuery.get();

        // No need to redeclare allRegisteredPrograms here

        for (let i = 0; i < query.docs.length; i++) {
          let programDetailsQuery = await programQuery
            .doc(`${query.docs[i].data().programId}`)
            .get();

          let program = {
            ...query.docs[i].data(),
            id: query.docs[i].id,
            programDetails: { ...programDetailsQuery.data() },
          };
          allRegisteredPrograms.push(program);
        }

        dispatch({
          type: FETCH_ALL_APPLICANT_REGISTERED_PROGRAMS,
          payload: { allRegisteredPrograms },
        });
        dispatch(asyncActionFinish());
      } catch (error) {
        dispatch(asyncActionError());
        /// console.log(error);
      }
    }
  };
};

// Applicant PROGRAM REGISTER AND SIGNUP
export const programRegisterAndSignup = (creds, programId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const firestore = getFirestore();

    const registeredProgramQuery = firestore.collection('registeredPrograms');
    const programQuery = firestore.collection('programs').doc(programId);

    try {
      dispatch(asyncActionStart());
      // CREATE FIREBASE USER
      let createdUser = await firebase
        .auth()
        .createUserWithEmailAndPassword(creds.email, creds.password);

      const program = await programQuery.get();

      const profileImageURL =
        'data:image/png;base64,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';

      //   // FIRESTORE ADD NEW USER DETAILS
      let newUser = {
        ...creds,
        uid: createdUser.user.uid,
        firstName: creds.firstName,
        lastName: creds.lastName,
        fullName: creds.firstName + ' ' + creds.lastName,
        dob: creds.dob,
        citizen: creds.citizen,

        email: creds.email,
        mobileNumber: creds.mobileNumber,
        gradeLevel: creds.gradeLevel,
        isAdmin: false,
        isReviewer: false,
        isApplicant: true,
        isAlumni: false,
        disabled: false,
        profileImageURL: profileImageURL,
        createdAt: new Date().toISOString(),
      };

      await firestore.set(`users/${createdUser.user.uid}`, { ...newUser });

      let createdAt = getUnixTime(new Date());
      let editiedAt = getUnixTime(new Date());

      // debugger;
      // SIGNUP TO PROGRAM
      let registeredProgram = await registeredProgramQuery.add({
        programId: programId,
        applicantId: createdUser.user.uid,
        // createdAt: firestore.FieldValue.serverTimestamp(),
        createdAt: createdAt,
        editiedAt: editiedAt,
        citizen: creds.citizen,

        firstName: creds.firstName,
        lastName: creds.lastName,
        fullName: creds.firstName + ' ' + creds.lastName,
        dob: creds.dob,
        programStatus: 'pending',
        programStage: 'pre-application',
        email: creds.email,
        currentJuniorRisingSeniorSet: false,
        applicationFeePaid: program.data().freeProgram ? true : false,
        applicantUpliftCodeSet: false,
        payment1Received: program.data().freeProgram ? true : false,
        payment2Received: program.data().freeProgram ? true : false,
        applicationCompleted: false,
        ...(program.data().earlyAdmissions &&
          new Date(program.data().earlyAdmittanceDeadline) > new Date() &&
          new Date(program.data().applicationOpen) < new Date() && {
          earlyAdmission: true,
        }),
      });

      analytics.logEvent('program_register');

      await axios.get('/applicantSignupFunctions/newSignup', {
        params: {
          fullName: creds.firstName + ' ' + creds.lastName,
          email: creds.email,
        },
      });

      await axios.get('/applicantApplicationFunctions/sendApplicationStarted', {
        params: {
          id: registeredProgram.id,
          applicantFirstName: creds.firstName,
          applicantLastName: creds.lastName,
          applicantEmail: creds.email,
        },
      });

      dispatch(asyncActionFinish());
      dispatch(closeDialog());

      return registeredProgram;
    } catch (error) {
      dispatch(asyncActionError());
      let errorMessage = '';
      if (error.message === 'The email address is badly formatted.') {
        errorMessage = 'Please enter a valid email address.';
      }

      if (
        error.message ===
        'The email address is already in use by another account.'
      ) {
        errorMessage = 'Email already exists.';
      }

      return errorMessage;
    }
  };
};

// Applicant PROGRAM REGISTER
export const programRegister = (profile, programId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    // const firebase = getFirebase();
    const firestore = getFirestore();

    const registeredProgramQuery = firestore.collection('registeredPrograms');
    const programQuery = firestore.collection('programs').doc(programId);

    try {
      dispatch(asyncActionStart());
      let createdAt = getUnixTime(new Date());
      let editiedAt = getUnixTime(new Date());

      const program = await programQuery.get();

      /// console.log('program :>> ', program);

      // debugger;
      // SIGNUP TO PROGRAM
      let registeredProgram = await registeredProgramQuery.add({
        programId: programId,
        applicantId: profile.uid,
        createdAt: createdAt,
        editiedAt: editiedAt,
        firstName: profile.firstName,
        lastName: profile.lastName,
        fullName: profile.firstName + ' ' + profile.lastName,
        dob: profile.dob,
        programStatus: 'pending',
        programStage: program.data().freeProgram
          ? 'in-progress'
          : 'pre-application',
        email: profile.email,
        currentJuniorRisingSeniorSet: false,
        applicationFeePaid: program.data().freeProgram ? true : false,
        applicantUpliftCodeSet: false,
        payment1Received: program.data().freeProgram ? true : false,
        payment2Received: program.data().freeProgram ? true : false,
        applicationCompleted: false,
        ...(program.data().earlyAdmissions &&
          new Date(program.data().earlyAdmittanceDeadline) > new Date() &&
          new Date(program.data().applicationOpen) < new Date() && {
          earlyAdmission: true,
        }),
      });

      analytics.logEvent('program_register');

      await axios.get('/applicantApplicationFunctions/sendApplicationStarted', {
        params: {
          id: registeredProgram.id,
          applicantFirstName: profile.firstName,
          applicantLastName: profile.lastName,
          applicantEmail: profile.email,
        },
      });

      dispatch(asyncActionFinish());
      return registeredProgram;
    } catch (error) {
      dispatch(asyncActionError());
      let errorMessage = '';
      throw new SubmissionError({
        _error: errorMessage,
      });
    }
  };
};

// APPLICATION PROCESS

// UPDATE Program Packet Downloaded
export const updateProgramPacketDownloaded = (id) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      const registeredProgram = await registeredProgramQuery.get();
      await registeredProgramQuery.update({
        programPacketDownloaded: true,
        logs: [
          ...registeredProgram.data()?.logs,
          {
            event: 'Program Packet Downloaded',
            date: getUnixTime(new Date()),
          },
        ],
      });

      dispatch(fetchRegisteredProgram(id));

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// UPDATE Applicant TYPE
export const updateApplicantType = (id, value) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      let editiedAt = getUnixTime(new Date());
      await registeredProgramQuery.update({
        editiedAt: editiedAt,
        currentJuniorRisingSeniorSet: true,
        currentJuniorRisingSenior: value.currentJuniorRisingSenior,
      });

      dispatch(fetchRegisteredProgram(id));

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// UPDATE APPLICATION FEE STATUS
export const updateApplicationFeePaid = (
  id,
  paymentId,
  program,
  applicantId,
  applicantName
) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    const paymentTransactionQuery = firestore.collection('paymentTransactions');

    try {
      dispatch(asyncActionStart());
      let editiedAt = getUnixTime(new Date());
      if (paymentId === null) {
        await registeredProgramQuery.update({
          editiedAt: editiedAt,
          applicationFeePaid: true,
          // applicationFeePaymentId: paymentId,
          programStage: 'in-progress',
        });
      }

      if (paymentId !== null) {
        await registeredProgramQuery.update({
          editiedAt: editiedAt,
          applicationFeePaid: true,
          applicationFeePaymentId: paymentId,
          programStage: 'in-progress',
        });

        const todaysDate = new Date().toISOString();
        await paymentTransactionQuery.add({
          paymentType: 'applicationFee',
          paymentDate: todaysDate,
          paymentYear: format(parseISO(todaysDate), 'y'),
          paymentId: paymentId,
          paymentFee: program.applicationFee,
          applicantId: applicantId,
          programId: program.id,
          applicantName: applicantName,
        });
      }

      dispatch(fetchRegisteredProgram(id));

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// AFFILIATE CODE
export const applyAffiliateCode = (id, profile, values) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const affiliateCode = values.affiliateCode?.toLocaleUpperCase();

    const affiliateQuery = firestore
      .collection('affiliates')
      .where('affiliateCode', '==', affiliateCode);

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      let query = await affiliateQuery.get();
      let registeredProgram = await registeredProgramQuery.get();

      let data = '';

      if (query.docs.length > 0) {
        let affiliate;

        for (let doc in query.docs) {
          if (
            query.docs[doc].data().programsAffiliated &&
            query.docs[doc]
              .data()
              .programsAffiliated.includes(registeredProgram.data().programId)
          ) {
            affiliate = query.docs[doc].data();
          }
        }
        if (affiliate) {
          if (new Date() <= new Date(affiliate.affiliateCodeExpiryDate)) {
            await registeredProgramQuery.update({
              promoCodeApplied: true,
              promoCode: affiliateCode,
              scholarshipFormCompleted: affiliate?.scholarshipWaiver
                ? true
                : false,
              taxFormsUploaded: affiliate?.scholarshipWaiver ? true : false,
              scholarshipFormDetails: affiliate?.scholarshipWaiver
                ? {
                  applyForAScholarship: 'No',
                  documentsTrueAndCorrect: false,
                  qualifyForScholarship: true,
                  scholarEmail: '',
                  scholarFirstName: '',
                  scholarLastName: '',
                  scholarPhoneNumber: '',
                  sponsoringConsent: false,
                  understandRequiredDocuments: false,
                }
                : { ...registeredProgram.data()?.scholarshipFormDetails },
            });

            data = {
              message: 'PROMO APPLIED',
            };
          } else {
            data = {
              message: 'CODE EXPIRED',
            };
          }
        } else {
          data = {
            message: 'INCORRECT CODE',
          };
        }
      } else {
        data = {
          message: 'INCORRECT CODE',
        };
      }
      dispatch(asyncActionFinish());
      return data;
    } catch (e) {
      dispatch(asyncActionError());
      /// console.log(e);
    }
  };
};

// UPDATE Applicant UPLIFT CODE
export const updateApplicantUpliftCode = (id, value) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      let editiedAt = getUnixTime(new Date());
      await registeredProgramQuery.update({
        editiedAt: editiedAt,
        applicantUpliftCodeSet: true,
        applicantUpliftCode: value.applicantUpliftCode
          ? value.applicantUpliftCode
          : '',
      });

      dispatch(fetchRegisteredProgram(id));

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// ARCHIEVE PROGRAM
export const archiveProgram = (id, archiveComment) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      const registeredProgram = await registeredProgramQuery.get();
      await registeredProgramQuery.update({
        archive: true,
        archiveComment,
        logs: registeredProgram.data().logs
          ? [
            ...registeredProgram.data().logs,
            {
              event: 'Application Archived',
              date: getUnixTime(new Date()),
            },
          ]
          : [
            {
              event: 'Application Archived',
              date: getUnixTime(new Date()),
            },
          ],
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};

// RESTORE PROGRAM
export const restoreProgram = (id) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const registeredProgramQuery = firestore
      .collection('registeredPrograms')
      .doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      const registeredProgram = await registeredProgramQuery.get();
      await registeredProgramQuery.update({
        archive: false,
        archiveComment: '',
        logs: registeredProgram.data().logs
          ? [
            ...registeredProgram.data().logs,
            {
              event: 'Application Restored',
              date: getUnixTime(new Date()),
            },
          ]
          : [
            {
              event: 'Application Restored',
              date: getUnixTime(new Date()),
            },
          ],
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      /// console.log(error);
    }
  };
};
